import React, { useState } from 'react';
import { Select } from '@mantine/core';
import { FieldProps } from '../form-helpers';
import { SelectCaret } from './SelectCaret';

export type FormFieldBooleanProps = Omit<FieldProps, 'value' | 'onChange'> & {
    value: string;
    onChange: (value: string) => void;
};

function FormFieldBoolean({ label, required, value, onChange, error, disabled, inTable }: FormFieldBooleanProps) {
    const [dropdownOpened, setDropdownOpened] = useState(false);

    return (
        <Select
            label={label}
            required={required}
            data={['Yes', 'No']}
            value={value || null}
            onChange={(val) => onChange(val ?? '')}
            error={error}
            disabled={disabled}
            clearable
            mt="sm"
            maw={inTable ? '100%' : undefined}
            onDropdownOpen={() => setDropdownOpened(true)}
            onDropdownClose={() => setDropdownOpened(false)}
            rightSection={<SelectCaret dropdownOpened={dropdownOpened} showClear={!!value && !disabled} onClear={() => onChange('')} />}
        />
    );
}

export default React.memo(FormFieldBoolean);
